export default __webpack_public_path__ + "static/media/jose--tablet@2x.fc985f8d.jpg";